/**
 * DOM Utility
 */
export interface ElementInfo {
  tag: string;
  attributes?: {
    [key: string]: string | boolean | undefined;
  };
  events?: {
    [key: string]: EventListenerOrEventListenerObject | undefined;
  };
  children?: (ElementInfo | string)[];
}

export const createElement = (elementInfo: ElementInfo): HTMLElement => {
  const tag = elementInfo?.tag;
  const attributes = elementInfo?.attributes || {};
  const events = elementInfo?.events || {};
  const children = elementInfo?.children || [];

  const element = document.createElement(tag || 'div');
  if (elementInfo) {
    for (const [key, value] of Object.entries(attributes)) {
      if (value !== undefined) {
        if (tag === 'input' && key === 'checked') {
          (<HTMLInputElement>element).checked = value as boolean;
        } else {
          element.setAttribute(key, `${value}`);
        }
      }
    }

    for (const [event, handler] of Object.entries(events)) {
      if (handler !== undefined) {
        element.addEventListener(event, handler);
      }
    }

    if ((tag === 'div' || tag === 'span') && children.length === 0) {
      return element;
    }

    for (const child of children) {
      if (typeof child === 'string') {
        element.appendChild(document.createTextNode(child));
      } else {
        const childElement = createElement(child);
        if (childElement) element.appendChild(childElement);
      }
    }
  }

  return element;
};
